import { Image as ImageModel } from "@/types/Image";
import clsx from "clsx";
import Image from "next/image";

export default function StaticDegradeImage({
  props,
  className,
}: {
  props: ImageModel;
  className?: string;
}) {
  return (
    <>
      <div className="relative overflow-hidden pt-16">
        <div className={clsx("mx-auto max-w-7xl ", className)}>
          <Image
            src={props.source}
            alt={props.alt}
            title={props.title}
            className="mb-[-5%] rounded-xl shadow-2xl ring-1 ring-gray-900/10"
            width={2432}
            height={1442}
          />

          <div className="relative" aria-hidden="true">
            <div className="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]" />
          </div>
        </div>
      </div>
    </>
  );
}
